import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { CompanyService } from 'src/app/app/company/company.service';
import { PopoverButton } from 'src/app/app/_component/popover/popover.model';
import { globalHelper } from 'src/app/_helpers/global';
import { UserBasic } from 'src/app/_models/user.model';
import { UserService } from 'src/app/_services';
import { ThisPlatform } from 'src/app/_services/platform.service';
import { HTMLClipper } from '../../../_helpers/turncateHtml';
import { ImagePreviewComponent } from '../../_component/image-preview/image-preview.component';
import { Community, CommunityType } from '../community.model';
import { CommunityService } from '../community.service';
@Component({
  selector: 'app-item-community',
  templateUrl: './item-community.component.html',
  styleUrls: ['./item-community.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ItemCommunityComponent implements OnInit {
  type = CommunityType;
  rowsVisibleInitCount = 5;
  rowsAddVisible = 1;
  description: SafeHtml;

  maxDescriptionLength: number;
  artificialSpace = false;

  @ViewChild('descriptionContainer')
  descriptionContainer: ElementRef;

  @Input()
  currentSegment: string;

  @Input()
  community: Community;

  @Input()
  singleArticle = false;

  @Input()
  refreshCommentsOnInit = false;

  @Input()
  subscribedFilter: Observable<void>;
  actualSubscription: Subscription;

  @Input()
  communityAdmin: boolean = false;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  // @Output()
  // keyboardOnScreen: EventEmitter<boolean> = new EventEmitter<boolean>();

  buttonList: PopoverButton[] = [
    {
      name: 'EDIT',
      icon: '../../../../assets/icons/edit-pen.svg',
      eventType: 'edit',
    },
    {
      name: 'DELETE',
      icon: 'trash',
      eventType: 'delete',
    },
  ];
  isTrip: boolean;

  constructor(
    public communityService: CommunityService,
    public userServ: UserService,
    public companyServ: CompanyService,
    public popoverController: PopoverController,
    private router: Router,
    private route: ActivatedRoute,
    public alertController: AlertController,
    public translateService: TranslateService,
    public loadingCtrl: LoadingController,
    public communityServ: CommunityService,
    private sanitizer: DomSanitizer,
    private modalController: ModalController,
    private p: ThisPlatform
  ) { }

  ngOnInit() {
    if (this.p.renderMobile) {
      this.maxDescriptionLength = 250;
      this.buttonList = this.buttonList.filter((button) => button.name !== 'EDIT');
    } else {
      this.maxDescriptionLength = 500;
    }

    if (this.community.description) {
      if (
        !this.singleArticle &&
        this.community.description?.length > this.maxDescriptionLength
      ) {
        let cuttedHtml = HTMLClipper.truncateHTML(
          this.community.description,
          this.maxDescriptionLength
        );
        // cuttedHtml += `<span style='color: red; cursor: pointer;'>${this.translateService.instant(
        //   "MORE_RESULT"
        // )}</span>`;

        this.description = this.sanitizer.bypassSecurityTrustHtml(
          cuttedHtml.replace(/\r?\n|\r/g, '')
        );
      } else {
        this.description = this.sanitizer.bypassSecurityTrustHtml(
          this.community.description.replace(/\r?\n|\r/g, '')
        );
      }
    } else {
      this.description = "";
    }

    this.isTrip = Number(this.currentSegment) == CommunityType.IntegrationTrip;
  }

  checkPermission(): Boolean {
    if (this.community.idUserCreated === this.userServ.userStorage.id) {
      return true;
    } else {
      return this.communityAdmin;
    }
  }

  onReroute() {
    if (!this.singleArticle) {
      switch (Number(this.currentSegment)) {
        case CommunityType.IntegrationTrip:
          this.router.navigate([
            `/app/integration-trip/detail-community/${this.community.id}`,
          ]);
          break;
        case CommunityType.GoodPracticesList:
          this.router.navigate([
            `/app/practices-list/detail-community/${this.community.id}`,
          ]);
          break;
        default:
          this.router.navigate([
            `/app/community/detail-community/${this.community.id}`,
          ]);
          break;
      }
    }
  }

  async presentPopover(ev: any, param: Community) {
    let popover = await globalHelper.Popover(
      this.popoverController,
      ev,
      this.buttonList,
      'community__popover'
    );
    if (popover) {
      if (popover.data === 'edit') {
        this.editEvent(param.id);
      }
      if (popover.data === 'delete') {
        this.deleteEvent(param.id);
      }
    }
  }

  async onImagePreview($event, url) {
    $event.stopPropagation();
    $event.preventDefault();

    const modal = await this.modalController.create({
      component: ImagePreviewComponent,
      componentProps: { src: url },
      animated: true,
      cssClass: 'image-preview-present',
    });
    modal.present();
  }

  getUserInitials(user: UserBasic) {
    if (!user.firstName) return;
    let { firstName, lastName } = user;
    return firstName[0] + (lastName ? lastName[0] : '');
  }

  editEvent(id) {
    switch (Number(this.currentSegment)) {
      case CommunityType.IntegrationTrip:
        this.router.navigateByUrl(
          'app/integration-trip/edit-community/' + this.currentSegment + '/' + id
        );
        break;
      case CommunityType.GoodPracticesList:
        this.router.navigateByUrl(
          'app/practices-list/edit-community/' + this.currentSegment + '/' + id
        );
        break;
      default:
        this.router.navigateByUrl(
          'app/community/edit-community/' + this.currentSegment + '/' + id
        );
        break;
    }
  }

  ifDatesAreDiffrent() {
    if (
      new Date(this.community.startTime).setHours(0, 0, 0, 0) !==
      new Date(this.community.endTime).setHours(0, 0, 0, 0)
    ) {
      return true;
    } else {
      return false;
    }
  }

  async deleteEvent(id: number) {
    this.popoverController.dismiss();

    let confirm = await globalHelper.Alert(
      this.alertController,
      this.translateService
    );
    if (confirm) {
      this.loadingCtrl
        .create({
          keyboardClose: true,
          message: this.translateService.instant('DELETING'),
        })
        .then((loadingEl) => {
          loadingEl.present();
          this.communityServ.deleteCommunity(Number(id)).subscribe(() => {
            loadingEl.dismiss();
            this.refreshAndBack();
          });
        });
    }
  }

  refreshAndBack() {
    this.communityServ.community = new Community();
    this.refreshRequest.emit();
    switch (Number(this.currentSegment)) {
      case CommunityType.IntegrationTrip:
        this.router.navigateByUrl('app/integration-trip?section=1');
        break;
      case CommunityType.GoodPracticesList:
        this.router.navigateByUrl('app/practices-list');
        break;
      default:
        this.router.navigateByUrl('app/community?section=' + Number(this.currentSegment));
        break;
    }
  }

  navigateTo() {
    switch (Number(this.currentSegment)) {
      case CommunityType.IntegrationTrip:
        this.router.navigateByUrl(
          '/app/integration-trip/detail-community/' + this.community.id
        );
        break;
      case CommunityType.GoodPracticesList:
        this.router.navigateByUrl(
          'app/practices-list/detail-community/' + this.community.id
        );
        break;
      case CommunityType.Agenda:
        this.router.navigateByUrl(
          'app/integration-trip/detail-community/' + this.community.id
        );
        break;
      default:
        this.router.navigateByUrl(
          'app/community/detail-community/' + this.community.id
        );
        break;
    }
  }

  getDuration(): string {
    if (!this.community?.startTime || !this.community?.endTime) return '';

    const start = new Date(this.community.startTime);
    const end = new Date(this.community.endTime);
    const diffMs = end.getTime() - start.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMins / 60);
    const mins = diffMins % 60;
    
    if (hours > 0 && mins === 0) {
      return `${hours}h`;
    }
    
    if (hours > 0) {
      return `${hours}h ${mins}min`;
    }
    
    return `${mins}min`;
  }

  isPublished(publishDate: Date): boolean {
    return (new Date(publishDate) > new Date());
  }
}
